import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions as modalsAction } from '@gerenciatd/next.app-controller.reducers-sagas.modals-reducer';
import Modal from '@gerenciatd/next.components.modal';
import MetaData from '@gerenciatd/next.app-controller.meta-data';
import { getCookie } from '@gerenciatd/next.utils.common';
import RouteHandler from '@/components/route-handler-n';
import OneTrust from '@/components/one-trust';
import ErrorBoundary from '@gerenciatd/next.app-controller.error-boundary-n'
import mainSetup from '@/config/mainSetup';
import { wrapper } from '@/store';
import dynamic from 'next/dynamic';
import '@/styles/globalVars.css';
/* [STYLES] begins */
import '@/styles/button-n.style.css';
import '@/styles/custom-link.style.css';
import '@/styles/image-n.style.css';
import '@/styles/header-n.style.css';
import '@/styles/count-down-date-timer-n.style.css';
import '@/styles/faqs-m.style.css';
import '@/styles/modal.style.css';
import '@/styles/icon-n.style.css';
import '@/styles/price.style.css';
import '@/styles/input.style.css';
import '@/styles/icon-label-n.style.css';
import '@/styles/footer.style.css';
import '@/styles/lego-component.style.css';
import '@/styles/label.style.css';
import '@/styles/text-info-n.style.css';
import '@/styles/customizer-component-edition.css';
/* [STYLES] ends */

import '@/styles/header_tuning.css';
import '@/styles/footer_tunning.style.css';


const shouldLoadDyna = (probability=10) => {
  let res = false;
  let probability2Apply = probability;
  
  if (typeof window !== 'undefined'){
    const cookiesAcepted = getCookie('OptanonAlertBoxClosed');
    const urlParams = new URLSearchParams(window.location.search);
    let paramValue = urlParams.get('dyna');
    if (paramValue) {
      probability2Apply = parseInt(paramValue, 10);
    }
    res = cookiesAcepted ? (Math.random() < (probability2Apply / 100)) : false;
  }
  return res;
}

let ToolBar = null;

const App = ({ Component, pageProps }) => { 
  const dispatch = useDispatch();
  const seoInfo = useSelector((state) => state.main.currentSeo);
  useEffect(() => {
    if (shouldLoadDyna()) {
      var dynaScript = document.createElement("script");
      dynaScript.setAttribute("src", "https://prod.cms.col.movistar.es/static/js/dynatrace/dyna.js");
      dynaScript.setAttribute("async", "true");
      dynaScript.setAttribute("defer", "true");
      dynaScript.setAttribute("crossorigin", "anonymous");
      document.body.appendChild(dynaScript);
    }
  }, [])

  

  if(`${process.env.NEXT_PUBLIC_ALLOW_EDIT}` === 'true') {
    ToolBar = dynamic(() => import ('@/components/customizer-component/toolbar'))
  }

  const handlerModals = (args) => {
    dispatch(modalsAction.addModal(args));
  };


  return (
    <>
      <MetaData seoInfo={seoInfo} />
      <RouteHandler />
      <Modal
        key="app-modal"
        className="app-root"
        projectId={mainSetup.projectId}
        reduxDispatchActions={handlerModals}
      />

      <OneTrust />

      <ErrorBoundary>
        <Component {...pageProps} />
      </ErrorBoundary>
      {ToolBar && (<ToolBar />)}
    </>
  );
};

export default wrapper.withRedux(App);
